import { Table } from "@mantine/core";

import { TextWrapper } from "@/components/TextWrapper";

import { MissingServicesThProps } from "./types/missing-services";

/** A plain, unsortable column header. `MissingServicesTable` renders `SortableTh` directly instead for the one column that has a `sortKey`. */
export default function MissingServicesTh({ children, column }: MissingServicesThProps) {
  return (
    <Table.Th w={column.width} ta={column.align}>
      <TextWrapper size="md" c="dark.9" variant="bold">
        {children}
      </TextWrapper>
    </Table.Th>
  );
}
